import { inject, Injectable } from '@angular/core';
import { DialogService } from '@core/services/dialog.service';
import { LocationAccessBlockedDialogComponent } from './location-access-blocked-dialog.component';

@Injectable({ providedIn: 'root' })
export class LocationAccessBlockedDialogService {
  private dialog = inject(DialogService);

  openLocationAccessBlockedDialog(): void {
    this.dialog.open({
      contentComponent: LocationAccessBlockedDialogComponent,
      size: 'sm',
      title: 'LocationAccess.Blocked',
      hideFooter: true,
      type: 'warning',
    });
  }
}
